module.exports = __webpack_public_path__ + "static/img/empty.736e0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty.svg
// module id = oWFT
// module chunks = 62